export const OrbParallax = (() => {
	'use strict';

	function init() {


	var $parallaxOrbs = $('.orb-parallax');

	// orb parallax //
	if($parallaxOrbs.length) {

		$(window).on("load scroll", function() {

			window.requestAnimationFrame(function() {

				var windowTop = $(window).scrollTop();

				$parallaxOrbs.each(function(){

					var elementTop = $(this).offset().top,
					elementHeight = $(this).height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight,
					ratio;

					switch($(this).data('parallax')){
						case "xsmall": 
							ratio = -0.10;
							break;

						case "small": 
							ratio = -0.20;
							break;
						case "medium": 
							ratio = -0.30;
							break;
						case "large": 
							ratio = -0.40;
							break;
						case "xlarge": 
							ratio = -0.50;
							break;
					}

					$(this).css({
						transform: "translate3d(0," + scrolled * ratio + "px, 0)"
					});
				})

			});
		});

	} 
	}

	return {
		init: init
	};
})();
